import {bootstrapApplication} from '@angular/platform-browser';
import {provideRouter, withHashLocation} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {csrfInterceptor} from './app/csrf.interceptor';
import {APP_INITIALIZER} from '@angular/core';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';
import {AdminI18nService} from './app/core/i18n/admin-i18n.service';
import {UiToastService} from 'freyr-ui';
import {BuildVersionService} from './app/core/services/build-version.service';

function initializeI18n(i18n: AdminI18nService) {
  return () => i18n.init();
}

function initializeBuildVersion(buildVersionService: BuildVersionService) {
  return () => buildVersionService.initialize();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([csrfInterceptor])),
    UiToastService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeI18n,
      deps: [AdminI18nService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBuildVersion,
      deps: [BuildVersionService],
      multi: true
    }
  ]
}).catch(err => console.error(err));

